import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Expenses/Expenses/tables";
import headers from "../../../../Data/Tables/Expenses/Expenses/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_expenses } from "../../../../Controllers/Expenses/Expenses";
import moment from "moment";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";

const ExpensesTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      category: headerdata?.category,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    console.log(data, "data");

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};

    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      category: headerdata?.category,
      sort: headerdata?.sort,
      date: headerdata?.date,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        category: tabledata?.category,
        sort: tabledata?.sort,
        date: tabledata?.date,
        page: tabledata?.currentPage,
      };

      const expenses = await get_all_expenses(params);

      if (expenses?.status) {
        let data = [];

        expenses?.data?.data?.map((value, index) => {
          data?.push({
            Number: value?.number ? `#EX-${value?.number}` : "",
           Date: value?.date
              ? <DateTimeBadge date={value?.date} />
              : "",
            Category: value?.category?.name,
            Amount: value?.amount ? value?.amount?.toFixed?.(3) : "",
            Action: (
              <ActionButton
                edit={`/app/expenses/edit/${value?._id}`}
                id={value?._id}
                api="delete-expense"
                actiondata={actiondata}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: expenses?.data?.currentPage,
          totalCount: expenses?.data?.totalCount,
          totalPages: expenses?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(expenses?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });

    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ExpensesTable;
